import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/foldersIconPrimary.svg'
import _imports_1 from '@/assets/filesIconPrimary.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "flex items-center justify-center w-full h-16 mt-4 tableCornerRadius bg-white" }
const _hoisted_3 = {
  key: 1,
  class: "tableCornerRadius bg-white"
}
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "center-content flex" }
const _hoisted_11 = {
  key: 4,
  class: "flex"
}
const _hoisted_12 = {
  key: 5,
  class: "flex"
}
const _hoisted_13 = { key: 6 }
const _hoisted_14 = { class: "pl-5 flex" }
const _hoisted_15 = {
  key: 7,
  class: "flex"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = ["value"]
const _hoisted_23 = ["value"]
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = ["value"]
const _hoisted_26 = ["value"]
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_34 = ["colspan"]
const _hoisted_35 = { class: "flex items-center justify-center w-full h-16" }
const _hoisted_36 = {
  key: 1,
  class: "emptyFixed"
}
const _hoisted_37 = { class: "cursor-pointer rowHeight" }
const _hoisted_38 = ["colspan"]
const _hoisted_39 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "table-ellipsis" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "center-content" }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = ["onMousemove"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 4 }
const _hoisted_50 = { key: 5 }
const _hoisted_51 = { class: "flex rounded w-32 items-center justify-center py-1 regular text-xs" }
const _hoisted_52 = { class: "text-xs" }
const _hoisted_53 = {
  key: 6,
  class: "flex justify-end"
}
const _hoisted_54 = ["onMousemove"]
const _hoisted_55 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.dotsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_dots_loader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames || [], (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    scope: "col",
                    key: column,
                    class: _normalizeClass(["bg-white cursor-pointer capitalize", _ctx.getColumnHeadWidth(column)]),
                    onClick: ($event: any) => (_ctx.sort(column))
                  }, [
                    (column == 'documentImage')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                      : (column == 'fileImage')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                        : (column == 'numberOfFiles')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[1] || (_cache[1] = [
                              _createElementVNode("div", { class: "center-content flex" }, _toDisplayString('Number Of Files'), -1)
                            ])))
                          : (column == 'createdDate')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _cache[2] || (_cache[2] = _createTextVNode(_toDisplayString('Created Date') + " ")),
                                  (column !== 'Action')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                      }, null, 2))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : (column == 'documentName')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _cache[3] || (_cache[3] = _createTextVNode(_toDisplayString('Name') + " ")),
                                  (column !== 'Action')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                      }, null, 2))
                                    : _createCommentVNode("", true)
                                ]))
                              : (column == 'documentId')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _cache[4] || (_cache[4] = _createTextVNode(_toDisplayString('ID') + " ")),
                                    (column !== 'Action')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                        }, null, 2))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (column == 'statusCode')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createElementVNode("div", _hoisted_14, [
                                        _cache[5] || (_cache[5] = _createTextVNode(_toDisplayString('Status') + " ")),
                                        (column !== 'Action')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                            }, null, 2))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      (column !== 'Action')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(column), 1))
                                        : _createCommentVNode("", true),
                                      (column !== 'Action')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                                          }, null, 2))
                                        : _createCommentVNode("", true)
                                    ]))
                  ], 10, _hoisted_5))
                }), 128)),
                (_ctx.visibility)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames || [], (name, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "bg-white",
                          key: index
                        }, [
                          (name == 'statusCode')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: _normalizeClass(_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filters.name,
                                  disabled: "",
                                  selected: "",
                                  hidden: ""
                                }, "Select", 8, _hoisted_19),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docStatusValues, (value, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: index,
                                    value: value.id
                                  }, _toDisplayString(value.value), 9, _hoisted_20))
                                }), 128))
                              ], 10, _hoisted_18)), [
                                [_vModelSelect, _ctx.filters[name]]
                              ])
                            : (name === 'type')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 1,
                                  class: _normalizeClass(_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                }, [
                                  _createElementVNode("option", {
                                    value: _ctx.filters.name,
                                    disabled: "",
                                    selected: "",
                                    hidden: ""
                                  }, "Select", 8, _hoisted_22),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docTypeData, (pair) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "optionColors",
                                      key: pair,
                                      value: pair.id
                                    }, _toDisplayString(pair.value), 9, _hoisted_23))
                                  }), 128))
                                ], 10, _hoisted_21)), [
                                  [_vModelSelect, _ctx.filters[name]]
                                ])
                              : (name == 'classification')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 2,
                                    class: _normalizeClass(_ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filters.name,
                                      selected: "",
                                      hidden: "",
                                      disabled: ""
                                    }, "Select", 8, _hoisted_25),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classificationData, (pair) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: pair,
                                        value: pair.id
                                      }, _toDisplayString(pair.value), 9, _hoisted_26))
                                    }), 128))
                                  ], 10, _hoisted_24)), [
                                    [_vModelSelect, _ctx.filters[name]]
                                  ])
                                : (name == 'documentImage' || name == 'numberOfFiles' || name == 'createdDate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                                  : (name == 'fileImage')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                                    : (name == 'Action')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            placeholder: "Search",
                                            class: "searchForInputBoxStyling",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                          }, null, 8, _hoisted_31), [
                                            [_vModelText, _ctx.filters[name]]
                                          ])
                                        ]))
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.loadData == true)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                    _createElementVNode("tr", _hoisted_33, [
                      _createElementVNode("td", {
                        class: "relative h-5",
                        colspan: _ctx.columnNames.size
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_dots_loader)
                        ])
                      ], 8, _hoisted_34)
                    ])
                  ]))
                : (_ctx.sortedData.length == 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_36, [
                      _createElementVNode("tr", _hoisted_37, [
                        _createElementVNode("td", {
                          class: "relative h-10",
                          colspan: _ctx.columnNames.size
                        }, _cache[6] || (_cache[6] = [
                          _createElementVNode("div", { class: "flex justify-center" }, [
                            _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                          ], -1)
                        ]), 8, _hoisted_38)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData || [], (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row,
                          class: "cursor-pointer rowHeight"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames || [], (column) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: column,
                              onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse())),
                              class: _normalizeClass(["cursor-pointer relative", { 'w-20': column == 'documentImage' || column == 'fileImage' }]),
                              onClick: ($event: any) => (_ctx.actionOnClickingTableRow(row, index, column))
                            }, [
                              _createElementVNode("div", _hoisted_41, [
                                (column == 'documentImage')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[7] || (_cache[7] = [
                                      _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: "Document Icon",
                                        class: "w-6 h-6"
                                      }, null, -1)
                                    ])))
                                  : (column == 'fileImage')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[8] || (_cache[8] = [
                                        _createElementVNode("img", {
                                          src: _imports_1,
                                          alt: "Document Icon",
                                          class: "w-6 h-6"
                                        }, null, -1)
                                      ])))
                                    : (column == 'numberOfFiles' || column == 'createdDate')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                          _createElementVNode("div", _hoisted_45, _toDisplayString(row[column]), 1)
                                        ]))
                                      : (column == 'type')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                            _createElementVNode("div", {
                                              onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                            }, _toDisplayString(_ctx.docTypeData.find((l) => {
												return l.id == row[column];
											}).value), 41, _hoisted_47),
                                            (_ctx.pop == true && _ctx.tipColumn == column && _ctx.tipIndex == index)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                  _createVNode(_component_tool_tip, {
                                                    columnName: column,
                                                    tipText: _ctx.tipText,
                                                    styling: _ctx.styling
                                                  }, null, 8, ["columnName", "tipText", "styling"])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (column == 'classification')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _createElementVNode("div", null, _toDisplayString(_ctx.classificationData.find((l) => {
												return l.id == row[column];
											}).value), 1)
                                            ]))
                                          : (column == 'statusCode')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["text-center flex items-center justify-center relative rounded w-24 px-2.5 h-5 regular", _ctx.colorTextRequestStatus(row[column])])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["w-full h-full absolute opacity-10 rounded", _ctx.colorBgRequestStatus(row[column])])
                                                  }, null, 2),
                                                  _createElementVNode("div", _hoisted_51, [
                                                    _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.docStatusValues.find((l) => {
														return l.id == row[column];
													}).value), 1)
                                                  ])
                                                ], 2)
                                              ]))
                                            : (column === 'Action')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                                  _createVNode(_component_Button, {
                                                    type: "button",
                                                    icon: "pi pi-ellipsis-v",
                                                    onClick: ($event: any) => (_ctx.actionToggleMenu($event, index)),
                                                    style: {"background-color":"white","color":"black","border":"white"}
                                                  }, null, 8, ["onClick"]),
                                                  _createVNode(_component_Menu, {
                                                    ref_for: true,
                                                    ref: 'menu' + index,
                                                    model: _ctx.actionButtonItems(row),
                                                    popup: true,
                                                    class: "menuWidth"
                                                  }, null, 8, ["model"])
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", {
                                                  key: 7,
                                                  onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text')),
                                                  class: _normalizeClass(["ellipsis-container", column == 'version'?'pl-3':''])
                                                }, _toDisplayString(row[column]), 43, _hoisted_54))
                              ]),
                              (_ctx.pop == true && _ctx.sortedData[_ctx.tipIndex][column] == _ctx.tipText && _ctx.tipColumn == column && _ctx.tipIndex == index)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                    _createVNode(_component_tool_tip, {
                                      columnName: column,
                                      tipText: _ctx.tipText,
                                      styling: _ctx.styling
                                    }, null, 8, ["columnName", "tipText", "styling"])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 42, _hoisted_40))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
            ])
          ]),
          _createVNode(_component_pagination, {
            dynamicPagination: _ctx.dynamicPagination,
            onCurrentPageUpdate: _ctx.paginationUpdations,
            sortedData: _ctx.sortedData
          }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
        ]))
  ]))
}